
import React from 'react';
import { CheckCircle, Network, Layers, Share } from 'lucide-react';

const InterfacesFeatures = () => {
  const features = [
    {
      icon: <Network className="h-10 w-10 text-blue-700" />,
      title: 'API-Integration',
      description: 'Moderne REST- und SOAP-APIs zur nahtlosen Anbindung verschiedener Systeme und Anwendungen.',
      benefits: [
        'Schnelle Implementation durch standardisierte Protokolle',
        'Hohe Skalierbarkeit für wachsende Datenmengen',
        'Sicherheit durch moderne Authentifizierungsmethoden'
      ]
    },
    {
      icon: <Share className="h-10 w-10 text-blue-700" />,
      title: 'EDI & Datenaustausch',
      description: 'Automatisierter Austausch von Geschäftsdokumenten zwischen Ihrem Unternehmen und Partnern.',
      benefits: [
        'Unterstützung aller gängigen EDI-Formate',
        'Automatische Format-Konvertierung',
        'Zuverlässige Übertragungswege mit Protokollierung'
      ]
    },
    {
      icon: <Layers className="h-10 w-10 text-blue-700" />,
      title: 'ERP-Integration',
      description: 'Nahtlose Verbindung Ihres ERP-Systems mit anderen Geschäftsanwendungen und Plattformen.',
      benefits: [
        'Bidirektionale Synchronisation kritischer Daten',
        'Echtzeitaktualisierung über alle Systeme hinweg',
        'Reduzierung von Datensilos und Doppelerfassungen'
      ]
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Professionelle Schnittstellen-Lösungen</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Wir entwickeln maßgeschneiderte Schnittstellen, die Ihre Systeme nahtlos miteinander verbinden und den Datenaustausch automatisieren.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white p-6 rounded-xl shadow-lg border border-gray-100 hover:shadow-xl transition-shadow duration-300">
              <div className="mb-5">{feature.icon}</div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">{feature.title}</h3>
              <p className="text-gray-600 mb-6">{feature.description}</p>
              <ul className="space-y-2">
                {feature.benefits.map((benefit, i) => (
                  <li key={i} className="flex items-start">
                    <CheckCircle className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" />
                    <span className="text-gray-700">{benefit}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InterfacesFeatures;
